import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import LogoLink from 'components/LogoLink'

const menu = [
  {
    to: '/advanced/',
    children: 'Advanced CSS + Javascript',
  },
  {
    to: '/wordpress/',
    children: 'WordPress',
  },
  {
    to: '/react/',
    children: 'React',
  },

]

export default () => (
  <div className="flex justify-center items-center f2 px-bold flex-wrap pa4">
    <Helmet title="SuperHi → Project Guides" />
    <LogoLink />
    <ul className="list tc w-100 pl0">
      {menu.map(item => (
        <li>
          <Link className="black link hover-blue lh-title" {...item} />
        </li>
      ))}
    </ul>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/index.js